export const BLUBOT_GETSTREAM_ID = 'BluBot';
export const ANONYMOUS_USER_ID = '!anon';
